/** Keep aligned with `src/utils/gs1CheckDigit.ts`. */

export function gs1CheckDigit(payloadWithoutCheck: string): string {
  const digits = String(payloadWithoutCheck || '').replace(/\D/g, '');
  let sum = 0;
  const reversed = digits.split('').reverse();
  for (let i = 0; i < reversed.length; i++) {
    const n = Number(reversed[i]);
    sum += i % 2 === 0 ? n * 3 : n;
  }
  return String((10 - (sum % 10)) % 10);
}

export function isValidGs1(code: string): boolean {
  const raw = String(code || '').trim();
  if (![8, 12, 13, 14].includes(raw.length) || !/^\d+$/.test(raw)) return false;
  return gs1CheckDigit(raw.slice(0, -1)) === raw.slice(-1);
}

export function gtin14FromBarcode(code: string): string | undefined {
  const digits = String(code || '').replace(/\D/g, '');
  if (digits.length < 12 || digits.length > 14) return undefined;
  return digits.padStart(14, '0');
}
